// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"1e722659","79":"ca4c46d5","89":"c35dafcc","211":"51127c66","254":"77e43ef9","556":"c9a4d839","597":"9b54da82","647":"e0756c3c","901":"494a8b5e","973":"fdac1bb8"}[chunkId] + ".chunk.js";
};